// components/AuthenticationInner/ParticlesAuth.tsx
import React from 'react';
import withRouter from '../../Components/Common/withRouter';

interface ParticlesAuthProps {
    children: React.ReactNode;
    themeColor?: string; // Add themeColor prop
}

const ParticlesAuth = ({ children, themeColor }: ParticlesAuthProps) => {
    // Default gradient if no theme color provided
    const defaultGradient = 'linear-gradient(to right, #0b3b5c, #1e6f9f)';

    // Create gradient based on theme color or use default
    const bgGradient = themeColor
        ? `linear-gradient(to right, rgb(206 231 106), rgb(65 142 255))`
        : defaultGradient;

    return (
        <React.Fragment>
            <div className="auth-page-wrapper pt-5">
                <div className="auth-one-bg-position auth-one-bg" id="auth-particles">

                    {/* Dynamic background overlay with theme color */}
                    <div
                        className="bg-overlay"
                        style={{
                            background: bgGradient,
                            opacity: 0.9
                        }}
                    ></div>

                    <div className="shape">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
                            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
                        </svg>
                    </div>

                    {/* pass the children */}
                    {children}

                </div>

                <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <p className="mb-0 text-muted">&copy; {new Date().getFullYear()} {getCompanyName()}. Crafted with <i className="mdi mdi-heart text-danger"></i> by {getCompanyName()}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </React.Fragment>
    );
};

// Helper function to adjust color brightness
const adjustColor = (color: string, percent: number): string => {
    // Simple color adjustment - you might want to use a proper color library
    // This is a basic implementation for hex colors
    if (color.startsWith('#')) {
        const hex = color.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const newR = Math.min(255, Math.max(0, r + percent));
        const newG = Math.min(255, Math.max(0, g + percent));
        const newB = Math.min(255, Math.max(0, b + percent));

        return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
    }
    return color;
};

// Helper to get company name from somewhere (you might want to pass this as prop too)
const getCompanyName = (): string => {
    // You could get this from context, redux, or pass as prop
    return "Intelixent";
};

export default withRouter(ParticlesAuth);